import '@Global/modal';
import type {ReactElement} from 'react';
import {useEffect, useMemo, useState} from 'react';
import App from '@Components/app';
import {ModalContainer} from '@Components/modal-container';
import {renderApp} from '@Utils/renderApp.util';
import {FormMaker} from '@FormMakerReact/form-maker';
import type {FormMakerImmutableStore} from '@FormMakerReact/form-maker.types';
import {setFormMakerPublishState} from '@FormMakerReact/reducers/form-maker-publish-state-reducer';

export function FormMakerPage(): ReactElement {
  const [i18Loaded, setI18Loaded] = useState<boolean>(false);
  const formMakerStore = useMemo<FormMakerImmutableStore>(() => readFormMakerStore(), []);

  useEffect(() => {
    window.PMW.initI18next(window.PMW.LANGUAGE, () => {
      setI18Loaded(true);
    });
  }, []);

  useEffect(() => {
    seedFormMakerPublishState(formMakerStore);
  }, [formMakerStore]);

  if (!i18Loaded) {
    return <App />;
  }

  return (
    <App nonStrictModeChildren={<FormMaker store={formMakerStore} />}>
      <ModalContainer />
    </App>
  );
}

function readFormMakerStore(): FormMakerImmutableStore {
  return window.reactPageProps as FormMakerImmutableStore;
}

function seedFormMakerPublishState(store: FormMakerImmutableStore): void {
  window.PMW.redux.store.dispatch(
    setFormMakerPublishState({
      isSharedInTeam: store.isSharedInTeam,
    })
  );
}

renderApp(<FormMakerPage />, 'form-maker-react-app');
